import React from 'react';

const ClinicContext = React.createContext(null);

export const ClinicProvider = ClinicContext.Provider;

export default ClinicContext;